import { transformQueryParams } from "@shared/utils";
import { dataProvider, limit } from "./constants";

const fetchWithDataProvider = async (url: string) => {
  const res = await dataProvider.custom({
    method: "GET",
    url: url,
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_CMS_TOKEN}`,
    },
    options: {
      cache: "no-store",
    }
  });

  return res.data;
};

export const fetchArticles = async ({ pageParam, keyword }: any) => {
  const currentDate = new Date();
  currentDate.setUTCHours(0, 0, 0, 0);

  const url = transformQueryParams(`/api/articles`, {
    sort: { publishedDate: "desc" },
    filters: keyword ? {
      fullTitle: { $containsi: keyword },
      shortTitle: { $containsi: keyword },
      publishedDate: {
        $lte: currentDate.toISOString(),
      },
    } : {
      isRecommendedSearch: { $eq: true },
      publishedDate: {
        $lte: currentDate.toISOString(),
      },
    },
    pagination: {
      start: pageParam,
      limit: limit,
    },
  });

  return fetchWithDataProvider(url);
};

export const fetchProducts = async ({ pageParam, keyword }: any) => {
  const url = transformQueryParams(`/api/products`, {
    filters: keyword ? {
      name: { $containsi: keyword },
    } : {
      isRecommendedSearch: { $eq: true }
    },
    pagination: {
      start: pageParam,
      limit: limit,
    },
  });

  return fetchWithDataProvider(url);
};

export const fetchFaqs = async ({ pageParam, keyword }: any) => {
  const url = transformQueryParams(`/api/faqs`, {
    filters: keyword ? {
      title: { $containsi: keyword },
    } : {
      isRecommendedSearch: { $eq: true }
    },
    pagination: {
      start: pageParam,
      limit: limit,
    },
  });

  return fetchWithDataProvider(url);
};

export const normalizeArticles = (items: any[]) =>
  items.map((item) => {
    const parent = item.attributes?.categories && item.attributes?.categories.length > 0 ? item.attributes?.categories[0] : null;

    return {
      category: "article",
      title: item.attributes?.shortTitle,
      url: `/${parent}/${item.attributes?.slug}`,
      description: item.attributes?.fullTitle,
    };
  });

export const normalizeProducts = (items: any[]) =>
  items.map((item) => ({
    category: "product",
    title: item?.attributes.name,
    url: `${item?.attributes?.url}`,
    description: item.attributes?.description,
  }));

export const normalizeFaqs = (items: any[]) =>
  items.map((item) => ({
    category: "faq",
    title: item.attributes?.title,
    raw: item,
    description: item.attributes?.description,
  }));